import { render, staticRenderFns } from "./SuggestSearchItem.vue?vue&type=template&id=220ea752&"
import script from "./SuggestSearchItem.vue?vue&type=script&lang=js&"
export * from "./SuggestSearchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports